// export const sourceBaseForImage = "./build/images"; // for server
export const sourceBaseForImage = "./images";  // for local


// drmohame
// 47e#04hEk